
import { AxiosResponse } from 'axios'
import { requests } from '.'
import config from '../config'
interface ListFunnelProducts {
  locationId: string
  funnel: string
  step: string
}
interface CreateFunnelProduct {
  locationId: string
  funnel: string
  step: string
  name: string
  product: string
  price: string
  bumpProduct: boolean
  displayText: string
  authorizeAmount: number
}

interface UpdateFunnelProduct {
  name: string
  product: string
  price: string
  bumpProduct: boolean
  displayText: string
  authorizeAmount: number
}

interface GetTransactions {
  locationId: string
  offset: number
  limit:number
}

interface StopSplitTestsAndResetParams {
  locationId: string
  funnelId: string
  userId: string
}

interface UpgradeFunnel {
  funnelId: string
  locationId: string
}

interface LookupAlreadyExistsParams {
  locationId: string
  domain: string
  path: string
}
interface AttachDomainParams {
  locationId: string
  domain: string
}
interface listDomainsParams {
  locationId: string
}
interface DeleteDomain {
  domainId: string
  locationId: string
}
interface InvalidateCacheParams {
  locationId: string
  domains: Array<string>
  event: string
}

interface DeleteFunnelParams {
  locationId: string
  funnelId: string
  userId: string
}


interface GetFunnelsParams {
  locationId: string
  type?: string
  category?: string
  offset?: string
  parentId?: string
  name?: string
}

interface CreateFolderParams {
  locationId: string
  type: string
  name: string
  userId: string
}

interface DeleteFolderParams {
  locationId: string
  id: string
  userId: string
}

interface MoveFunnelToFolderParams {
  locationId: string
  folderId: string
  funnelId: string
  userId: string
}

interface RenameFolderParams {
  locationId: string
  folderId: string
  name: string
  userId: string
}

interface GetFoldersParams {
  locationId: string
  type?: string
}

interface GetAllFoldersAndEntitiesParams {
  locationId: string
}

interface GetFunnelPagesByStepParams {
  locationId: string
  stepId: string
}

interface GetFunnelsByLocationAndDomainParams {
  locationId: string
  domainId: string
}

interface ResetFunnelStatsParams {
  funnelId: string
}

interface UpdateFunnelSettingsParams {
  locationId: string
  funnelId: string
  funnelName: string
  funnelPath: string
  domainId: string
  faviconUrl: string
  headTrackingCode: string
  bodyTrackingCode: string
  allowPaymentModeOption: boolean
  paymentMode: string
  chatWidget: string
  imageOptimization: boolean
}

interface CloneControlPageParams {
  locationId: string
  pageId: string
  stepName: string
  domainName: string
  alreadyExistingVariationPageId: string
}

interface CloneFunnelToLocations {
  funnelId: string
  funnelName: string
  locationIds: string[]
}

interface CloneFunnelStepParams {
  funnelId: string
  stepId: string
  funnels: Array<string>
  locationId: string
  userId: string
  stepIdToImportInto?: string
  funnelIdToImport?: string
  pageIndexToImport?: string
  pageIndexToImportInto?: string
}
interface RedirectExistForDomainParams {
  locationId: string
  domain: string
}

export interface OrderResponse {
  _id: string
  contactId: string
  amount: string
  companyId: string
  stripePlanId: string
  productId: string
  stripeProductId: string
  dateUpdated: Date
  currency: string
  chargeId: string
  funnelId: string
  locationId: string
  stripeCustomerId: string
  paymentType: string
  deleted: boolean
  dateAdded: Date
  stepId: string
  funnelPageId: string
  updatedAt: Date
}

interface GetOrderByLocationParams{
  locationId: string
  funnelId?: string
  stepId?: string
  startDate?:string
  endDate?:string
  limit:number
  skip?:number
}

interface CreateRedirect {
  locationId: string
  domain: string
  path: string
  target: string
  action: string
}

interface UpdateRedirect {
  target: string
  action: string
}

interface GetRedirects {
  locationId: string
  limit: number
  offset: number
}

interface GetShareFunnelUrlParams {
  shareWith:string
  funnelId:string
  companyId:string
  shareId?: string
}

export enum ShareWithType {
  ALL = 'ALL',
  AGENCY = 'AGENCY',
  REMOVE = 'REMOVE'
}

export interface ShareFunnelResponse {
  funnelName?: string
  funnelId?: string
  funnelType?: string
  dateAdded?: Date
  dateUpdated?: Date
  companyId?: string
  shareWith?: string
}

interface FunnelChild {
  id: string
  name: string
  pageId: string
  selected: boolean
  url: string
}

interface Funnel {
  id: string
  name: string
  opened: boolean
  selected: boolean
  children: Array<FunnelChild>
}

interface CustomPath {
  lastMod: string
  path: string
}

interface GenerateXMLSiteMapParams {
  locationId: string
  domainId: string
  mapping: Array<Funnel>
  custom: Array<CustomPath>
}
export interface FunnelResponse {
  steps: Step[]
  globalFonts: any[]
  deleted: boolean
  _id: string
  dateAdded: string
  dateUpdated: string
  domainId: string
  faviconUrl: string
  globalSectionsPath: string
  globalSectionsUrl: string
  isChatWidgetLive: boolean
  locationId: string
  name: string
  orderFormVersion: number
  processing: boolean
  trackingCodeBody: string
  trackingCodeHead: string
  type: string
  url: string
  updatedAt: string
  globalSectionVersion: number
}

export interface Step {
  id: string
  name: string
  pages: string[]
  products: any[]
  sequence: number
  type: string
  url: string
}

export interface UpdateFunnelParams {
  locationId?: string;
  name?: string;
  originId?: string;
  url?: string;
  faviconUrl?: string;
  trackingCodeHead?: string;
  trackingCodeBody?: string;
  domainId?: string;
  processing?: boolean;
  type?: string;
  globalSectionsPath?: string;
  globalSectionsUrl?: string;
  globalSectionVersion?: number;
  globalFonts?: any[];
  updatedBy?: string;
  orderFormVersion?: number;
  isLivePaymentMode?: boolean;
  deleted?: boolean;
  category?: string;
  parentId?: string;
  ischatWidgetLive?: boolean;
  imageOptimization?: boolean;
}

export interface LookupResponse {
  _id: string
  dateAdded: string
  dateUpdated: string
  deleted: boolean
  domain: string
  funnelId: string
  locationId: string
  path: string
  pathLowercase: string
  steps: string[]
  type: string
  typeId: string
  updatedAt: string
}

const FunnelsServices = {
  getById: (id: string) => requests(config.funnelsApiURL).get<{data:FunnelResponse}>(`/funnels/funnel/fetch/${id}`),
  updateFunnel: (params: { funnelId:string,payload:UpdateFunnelParams }) => requests(config.funnelsApiURL).patch<{ ok:boolean }>(`/funnels/funnel/update/${params.funnelId}`, params.payload),
  listFunnelProducts: (params: ListFunnelProducts) =>
    requests(config.funnelsApiURL).get('/funnels/order-form/products', {
      params,
    }),
  listFunnelProductsByStep: (funnelId:string) =>
    requests(config.funnelsApiURL).get(`/funnels/order-form/funnels/${funnelId}/products`),
  createFunnelProducts: (params: CreateFunnelProduct) =>
    requests(config.funnelsApiURL).post('/funnels/order-form/products', params),
  updateFunnelProducts: (id: string, params: UpdateFunnelProduct) =>
    requests(config.funnelsApiURL).put(
      `/funnels/order-form/products/${id}`,
      params
    ),
  deleteFunnelProduct: id =>
    requests(config.funnelsApiURL).delete(`/funnels/order-form/products/${id}`),
  findByFunnelProductId: id =>
    requests(config.funnelsApiURL).get(`/funnels/order-form/products/${id}`),
  getTransactions: (params:GetTransactions) =>
    requests(config.funnelsApiURL).get(`/funnels/transaction/list`, { params }),
  stopAllSplitTestsAndReset: (params:StopSplitTestsAndResetParams) =>
    requests(config.funnelsApiURL).post(`/funnels/funnel/stop-all-split-tests-and-reset`, params),
  upgradeFunnel: (body: UpgradeFunnel) =>
    requests(config.funnelsApiURL).post('/funnels/funnel/upgrade', body),
  rollbackUpgradeFunnel: (body: UpgradeFunnel) =>
    requests(config.funnelsApiURL).post('/funnels/funnel/upgrade/rollback', body),
  checkIfFunnelLookupAlreadyExists: (params:LookupAlreadyExistsParams) =>
    requests(config.funnelsApiURL).post(`/funnels/lookup/exists`, params),
  listDomains: (params: listDomainsParams) => requests(config.funnelsApiURL).get('/funnels/domain', { params }),
  deleteDomain: (params: DeleteDomain) => requests(config.funnelsApiURL).delete('/funnels/domain', { params }),
  attachDomain: (params:AttachDomainParams) =>
    requests(config.funnelsApiURL).post(`/funnels/domain/attach-domain`, params),
  invalidateCache: (params:InvalidateCacheParams) =>
    requests(config.funnelsApiURL).post(`/funnels/domain/invalidate-cache`, params),
  deleteFunnel: (params:DeleteFunnelParams) =>
    requests(config.funnelsApiURL).post(`/funnels/funnel/delete`, params),
  fetchFunnels: (params:GetFunnelsParams) =>
    requests(config.funnelsApiURL).get(`/funnels/funnel/list`, { params }),
  fetchFolders: (params:GetFoldersParams) =>
    requests(config.funnelsApiURL).get(`/funnels/funnel/folder/list`, { params }),
  createFolder: (params:CreateFolderParams) =>
    requests(config.funnelsApiURL).post(`/funnels/funnel/folder/create`, params),
  deleteFolder: (params:DeleteFolderParams) =>
    requests(config.funnelsApiURL).post(`/funnels/funnel/folder/delete`, params),
  renameFolder: (params:RenameFolderParams) =>
    requests(config.funnelsApiURL).post(`/funnels/funnel/folder/rename`, params),
  moveToFolder: (params:MoveFunnelToFolderParams) =>
    requests(config.funnelsApiURL).post(`/funnels/funnel/move`, params),
  getAllFoldersAndEntities: (params:GetAllFoldersAndEntitiesParams) =>
    requests(config.funnelsApiURL).get(`/funnels/funnel/folder/entities`, { params }),
  getFunnelPagesByStepId: (params:GetFunnelPagesByStepParams) =>
    requests(config.funnelsApiURL).get(`/funnels/funnel/step/pages`, { params }),
  getFunnelsByLocationAndDomain: (params:GetFunnelsByLocationAndDomainParams) =>
    requests(config.funnelsApiURL).get(`/funnels/funnel/list/by-location-and-domain`, { params }),
  updateFunnelSettings: (params:UpdateFunnelSettingsParams) =>
    requests(config.funnelsApiURL).post(`/funnels/funnel/update-settings`, params),
  cloneControlPage: (params:CloneControlPageParams) =>
    requests(config.funnelsApiURL).post(`/funnels/funnel/clone-control-page/`, params),
  cloneFunnelToLocations: (params: CloneFunnelToLocations) =>
    requests(config.funnelsApiURL).post('/funnels/funnel/clone-funnel-to-locations',params),
  cloneFunnelStep: (params:CloneFunnelStepParams) =>
    requests(config.funnelsApiURL).post(`/funnels/funnel/clone-funnel-step/`, params),
  checkIfRedirectExistForFomain: (params:RedirectExistForDomainParams) =>
    requests(config.funnelsApiURL).post(`/funnels/lookup/redirect-exists-for-domain/`, params),
  getOrdersByLocation: (params:GetOrderByLocationParams) : Promise<AxiosResponse<OrderResponse[]>> =>
    requests(config.funnelsApiURL).get(`/funnels/order`,{
      params
    }),
  getRedirects: (params:GetRedirects) =>
    requests(config.funnelsApiURL).get(`/funnels/lookup/redirect/list`, {
      params
    }),
  getLookupByTypeId: (typeId:string) => requests(config.funnelsApiURL).get<{data:LookupResponse}>(`/funnels/lookup/type/${typeId}`),
  createRedirect: (params: CreateRedirect) =>
    requests(config.funnelsApiURL).post(`/funnels/lookup/redirect`, params),
  updateRedirect: (id: string, params: UpdateRedirect) =>
    requests(config.funnelsApiURL).patch(`/funnels/lookup/redirect/${id}`, params),
  deleteRedirect: (id: string) =>
    requests(config.funnelsApiURL).delete(`/funnels/lookup/redirect/${id}`),
  getShareFunnelUrl: (params:GetShareFunnelUrlParams) : Promise<{ data:{data:{ shareId:string }} }> =>
    requests(config.funnelsApiURL).post(`/funnels/builder/funnel-share-url`,params),
  getShareFunnelById:(shareId:string) : Promise<{data:{data:ShareFunnelResponse}}> =>
    requests(config.funnelsApiURL).get(`/funnels/builder/funnel-share-url/${shareId}`),
  getShareFunnelDetails:(funnelId: string) : Promise<{ data:{data: { funnelName: string;shareWith: string;}} }> =>
    requests(config.funnelsApiURL).get(`/funnels/builder/funnel-share-details/${funnelId}`),
  generateXMLSiteMap: (params:GenerateXMLSiteMapParams) =>
    requests(config.funnelsApiURL).post('/funnels/domain/xml-sitemap', params),
  getClickFunnelHTML :(params:{ url:string }) =>
    requests(config.funnelsApiURL).get<{ html:string }>(`/funnels-infra/html`,{
      params
    }),
  getPageById: (pageId: string) => 
    requests(config.funnelsApiURL).get(`/funnels/page/${pageId}`)
}

export default FunnelsServices
